import React from "react";
import Upload from "../blocks/Upload/Upload";

export default function Home() {
    return <Upload />;
}
